import * as yup from "yup";
import { Schema } from "../../schema";
import { MultipleValueObject } from "../base-value-object";
export class Change extends MultipleValueObject {
    createdAt;
    createdBy;
    updatedAt;
    updatedBy;
    constructor(args) {
        super(args);
        this.createdAt = args.createdAt;
        this.createdBy = args.createdBy;
        this.updatedAt = args.updatedAt;
        this.updatedBy = args.updatedBy;
    }
    getValue() {
        return {
            createdAt: this.createdAt,
            createdBy: this.createdBy,
            updatedAt: this.updatedAt,
            updatedBy: this.updatedBy,
        };
    }
    validator(args) {
        return this.validate(args, Change.schema);
    }
    equals(_) {
        throw new Error("Method not implemented.");
    }
    toString() {
        throw new Error("Method not implemented.");
    }
    update(updater) {
        return new Change({
            createdAt: this.createdAt,
            createdBy: this.createdBy,
            updatedBy: updater,
            updatedAt: new Date(),
        });
    }
    static create(updater) {
        const now = new Date();
        return new Change({
            createdBy: updater,
            createdAt: now,
            updatedBy: updater,
            updatedAt: now,
        });
    }
    static hasChange(v) {
        return !!v.createdAt && !!v.createdBy && !!v.updatedAt && !!v.updatedBy;
    }
    static schema(required = true) {
        return Schema.required({
            createdAt: yup.date().label("createdAt"),
            createdBy: yup.string().label("createdBy"),
            updatedAt: yup.date().label("createdAt"),
            updatedBy: yup.string().label("updatedBy"),
        }, required);
    }
}
//# sourceMappingURL=change.js.map